import { isRouteErrorResponse, useRouteError } from 'react-router';

import NotFound from '@/components/route/NotFound';
import Error from '@/pages/Error';

const RouterErrorPage = () => {
  const error = useRouteError();

  if (isRouteErrorResponse(error) && error.status === 404) {
    return <NotFound />;
  }

  return <Error />;
};

export default RouterErrorPage;
